/** Generate a prompt from a configuration */

import { deepMerge } from '@tunasong/models'
import invariant from 'tiny-invariant'
import type { AIContext, AIContextSettings } from './schema/ai-schema.js'
import { aiSystemContextSettings } from './system-context-settings.js'

export const getPromptSpec = ({ context, userConfig }: { context: AIContext; userConfig?: AIContextSettings }) => {
  const globalConfig = aiSystemContextSettings.global
  const systemConfig = aiSystemContextSettings[context]

  invariant(systemConfig, `No system context settings found for context: ${context}`)

  // Merge the system settings with the user settings
  const config = deepMerge(globalConfig, systemConfig, userConfig)

  // Check that we have a specified provider and model
  invariant(config.model, 'No model specified in context settings')

  return config
}
